import React from "react";
import { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { useForm, ValidationError } from "@formspree/react";
import "./Contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { BsLinkedin, BsWhatsapp } from "react-icons/bs";
import "animate.css";
import AOS from "aos";

const Contact = () => {
  
  const [state, handleSubmit] = useForm("xyyoedgw");
  const [sent, setSent] = useState(false);
  function ContactForm() {
    if (state.succeeded && !sent) {
      // setLoader(false);
      setSent(true);
      document.getElementById("contactForm").reset();
    }
    return (
      <form
        method="POST"
        id="contactForm"
        onSubmit={handleSubmit}
        autoComplete="off"
        class="contact-form padd-15"
      >
        <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
            data-aos="fade-left"
            data-aos-delay="200"
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            data-aos="fade-left"
            data-aos-delay="400"
          />
          <textarea
            name="message"
            rows="7"
            placeholder="Your Message"
            required
            data-aos="fade-left"
            data-aos-delay="600"
          ></textarea>
          <button type="submit" className="btn btn-primary"
          data-aos="fade-down"
          data-aos-delay="800"
          >
            Send Message
          </button>
      </form>
    );
  }
  AOS.init();
  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article
            className="contact__option"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>hr607656@gmail.com</h5>
            <a href="mailto:hr607656@gmail.com" target="_blank" rel = "noreferrer">
              Send a message
            </a>
          </article>
          <article
            className="contact__option"
            data-aos="fade-right"
            data-aos-delay="400"
          >
            <BsLinkedin className="contact__option-icon" />
            <h4>LinkedIn</h4>
            <h5>Himanshu Rawat</h5>
            <a
              href="https://www.linkedin.com/in/himanshu-rawat0509/"
              target="_blank"
              rel = "noreferrer"
            >
              Click on message
            </a>
          </article>
          <article
            className="contact__option"
            data-aos="fade-right"
            data-aos-delay="600"
          >
            <BsWhatsapp className="contact__option-icon" />
            <h4>WhatsApp</h4>
            <h5>+91-9193581442</h5>
            <a href="https://wa.me/919193581442" target="_blank" rel = "noreferrer">
              Send a message
            </a>
          </article>
        </div>
        {/* END OF CONTACT OPTIONS */}
        
        {ContactForm()}
        
      </div>
    </section>
  );
};

export default Contact;